import { configureStore } from '@reduxjs/toolkit';
import resourcesReducer from './getResourcesSlice';
import cropNutritionReducer from './getCropNutritionSlice';
import trialResultsReducer from './getTrialResultsSlice';
import careerReducer from './getCareerSlice';
import jobsReducer from './getJobsSlice';
import newsReducer from './getNewsSlice';
import articlesReducer from './getArticlesSlice';

export const store = configureStore({
    reducer: {
        resources: resourcesReducer,
        cropNutrition: cropNutritionReducer,
        trialResults: trialResultsReducer,
        career: careerReducer,
        jobsState: jobsReducer,
        news: newsReducer,
        articlesState: articlesReducer,
    },
});

export default store;
